import backend, {COMMUNICATION_API} from 'utils/backend/server/api_library';
import queryString from 'query-string';

const createSmsSubscription = (userRn, phoneNumber) => {
  const url = `${COMMUNICATION_API}/user/${userRn}/sms/subscription`;
  const body = {
    phoneNumber,
  };
  return backend.post(url, body);
};

const getSmsSubscription = (userRn) => {
  const url = `${COMMUNICATION_API}/user/${userRn}/sms/subscription`;
  return backend.get(url);
};


const updateSmsSubscription = (userRn, phoneNumber, newSubscriptionStatus) => {
  const url = `${COMMUNICATION_API}/user/${userRn}/sms/subscription`;
  const body = {
    phoneNumber,
    subscribed: newSubscriptionStatus,
  };
  return backend.put(url, body);
};

const getConversationList = (caregiverRn) => {
  return backend.get(`${COMMUNICATION_API}/user/${caregiverRn}/conversation/conversations`);
};

const getConversationMessages = (caregiverRn, conversationRn, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey,
  };

  const query = queryString.stringify(queryParam, {
    skipNull: true,
    skipEmptyString: true,
  });

  return backend.get(`${COMMUNICATION_API}/user/${caregiverRn}/conversation/${conversationRn}/messages?${query}`);
};

export default {
  createSmsSubscription,
  getSmsSubscription,
  updateSmsSubscription,
  getConversationList,
  getConversationMessages,
};
